import { errors } from './errors'
import { events } from './events'
import { config } from './config'
import { DOM } from './DOM'
import { utils } from './utils'
import { page } from './page'

if (Number && Number.parseInt && Number.parseInt === undefined && window.parseInt) {
  Number.parseInt = window.parseInt
}

export class MK {
  constructor() {
    Object.assign(this,
      window.MK,
      errors.initialize(),
      events.initialize()
    )

    Object.assign(this, {
      active: (MK.active || {
        resolution: (window.innerWidth >= 1025 && 'desktop' || window.innerWidth <= 736 && 'mobile' || window.innerWidth >= 737 && window.innerWidth <= 1024 && 'tablet')
      }),
      activeResolution: (window.innerWidth >= 1025 && 'desktop' || window.innerWidth <= 736 && 'mobile' || window.innerWidth >= 737 && window.innerWidth <= 1024 && 'tablet'),
      config: config,
      cdnPath: `${process.env.CDN_PATH}`,
      cdnRoot: `${process.env.CDN_PATH}`,
      client: `${process.env.CLIENT}`,
      debug: `${process.env.DEBUG}`,
      DOM: DOM.initialize(),
      environment: `${process.env.NODE_ENV}`,
      initialized: {},
      page: page.initialize(),
      revision: `${process.env.GIT_REVISION}`,
      tld: (/eddiebauer\.ca/.test(window.location.host) ? 'eddiebauer.ca' : 'eddiebauer.com'),
      utils: utils.initialize()
    })

    console.log('DEBUG (MK) Initialized environment:', this)
  }
}

